import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {HasContactBaseMixin} from "../../widget/mixins/HasContactBaseMixin.jsx";
import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";

export default class ResourceContactTab extends HasContactBaseMixin(ResourceEditTabBase) {
  static get $name() {
    return "ResourceContactTab";
  }

  static get type() {
    return "resourcecontacttab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceEditorContactGridState;
  }

  get recordType() {
    return "resourceId";
  }

  getStoreData() {
    return this.record.contacts;
  }

  getStore() {
    return this.project.resourceContactsStore;
  }

  getEntityStoreKey() {
    return STORE_KEYS.resourceStore
  }
}

ResourceContactTab.initClass();